import { debounce } from 'lodash-es';
import { MutableRefObject, useEffect, useRef, useState } from 'react';
import SmallArrows from './SmallArrows';

const CustomSlider = ({ children }: { children: any }) => {
  const [left, setLeft] = useState(false);
  const [right, setRight] = useState(false);
  const containerRef: MutableRefObject<HTMLDivElement | null> = useRef(null);

  // Handle Arrows on Scroll
  const handleScroll = debounce((e) => {
    const { scrollLeft, clientWidth, scrollWidth } = e.target as HTMLElement;

    if (scrollLeft > 0) setLeft(true);
    else setLeft(false);

    if (scrollLeft + clientWidth === scrollWidth) setRight(false);
    else setRight(true);
  }, 300);

  // Initialize Right Arrow
  useEffect(() => {
    if (containerRef.current != null) {
      if (
        containerRef.current.scrollLeft + containerRef.current.clientWidth ===
        containerRef.current.scrollWidth
      )
        setRight(false);
      else setRight(true);
    }
  }, [containerRef]);

  return (
    <div
      // eslint-disable-next-line tailwindcss/no-custom-classname
      className="hide-scrollbar flex gap-2 overflow-x-auto overflow-y-hidden"
      onScroll={handleScroll}
      ref={containerRef}
    >
      {children}
      <SmallArrows
        containerRef={containerRef}
        scrollLeft={left}
        scrollRight={right}
      />
    </div>
  );
};

export default CustomSlider;
